import React from "react";
import { Box, CircularProgress, IconButton } from "@mui/material";

/**
 * iOS HIG-inspired play control: 64×64pt frosted circle, white triangle, press scale-down.
 */
export default function IOSPlayButton({
    onClick,
    disabled = false,
    loading = false,
    ariaLabel = "Play",
    sx,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                ...sx,
            }}
        >
            <IconButton
                type="button"
                onClick={onClick}
                disabled={disabled || loading}
                aria-label={ariaLabel}
                sx={{
                    width: 64,
                    height: 64,
                    minWidth: 64,
                    minHeight: 64,
                    borderRadius: "50%",
                    p: 0,
                    color: "#ffffff",
                    bgcolor: "rgba(59, 166, 102, 0.55)",
                    backdropFilter: "blur(20px) saturate(180%)",
                    WebkitBackdropFilter: "blur(20px) saturate(180%)",
                    border: "1px solid rgba(255, 255, 255, 0.45)",
                    boxShadow: "0 8px 28px rgba(15, 23, 42, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.35)",
                    WebkitTapHighlightColor: "transparent",
                    transition: "transform 0.14s cubic-bezier(0.25, 0.1, 0.25, 1), opacity 0.14s ease",
                    "&:active:not(.Mui-disabled)": {
                        transform: "scale(0.94)",
                    },
                    "&.Mui-disabled": {
                        opacity: 0.42,
                        color: "rgba(255, 255, 255, 0.85)",
                    },
                }}
            >
                {loading ? (
                    <CircularProgress size={26} sx={{ color: "#ffffff" }} />
                ) : (
                    <Box
                        component="span"
                        aria-hidden
                        sx={{
                            display: "block",
                            width: 0,
                            height: 0,
                            borderStyle: "solid",
                            borderWidth: "11px 0 11px 18px",
                            borderColor: "transparent transparent transparent #ffffff",
                            ml: "4px",
                        }}
                    />
                )}
            </IconButton>
        </Box>
    );
}
